import { FC } from 'react';
import cx from 'classnames/bind';
import { useMediaQuery } from 'react-responsive';

import { Layout } from '@/components/Layout';
import { Message } from '@/components/Message';
import { Button } from '@/components/Button';
import { Animation } from '@/components/Animation';
import { Header } from '../../Header';
import AnimationTraining from '@/assets/animations/training.json';
import AnimationBuyer1 from '@/assets/animations/buyer1.json';
import AnimationBuyer2 from '@/assets/animations/buyer2.json';
import AnimationBuyer3 from '@/assets/animations/buyer3.json';
import AnimationBuyer4 from '@/assets/animations/buyer4.gif';
import Cashbox from '@/assets/cashbox.png';
import CashboxTablet from '@/assets/cashboxTablet.png';
import CashboxDesktop from '@/assets/cashboxDesktop.png';
import type { IQuestion } from '@/types/question';
import type { IGame } from '@/types/game';

import styles from './Background.module.scss';

interface BackgroundProps {
  setStep: (value: number) => void;
  page: number;
  message: string;
  button: string;
  numberQuestion: number;
  questions: IQuestion[];
  idGame: number;
  setSelectedAnswer: (value: string[]) => void;
  scenarios: IGame[];
  points: number;
  responseStatus: { [x: number]: boolean | null };
}

const cn = cx.bind(styles);

const Background: FC<BackgroundProps> = ({
  setStep,
  page,
  message,
  button,
  numberQuestion,
  questions,
  idGame,
  setSelectedAnswer,
  scenarios,
  points,
  responseStatus,
}) => {
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });
  const isMobile = useMediaQuery({ query: '(max-width: 833px)' });
  const isTablet = useMediaQuery({ query: '(min-width: 834px)' });
  const isDesctop = useMediaQuery({ query: '(min-width: 1440px)' });

  const srcCashbox = isDesctop
    ? CashboxDesktop
    : isTablet
    ? CashboxTablet
    : Cashbox;

  const startTraining = () => {
    setStep(page);
    setSelectedAnswer([]);
  };

  const currentScenarioIndex = scenarios.findIndex(({ id }) => id === idGame);

  return (
    <>
      <div className={cn('background')} />
      {(!isMobile || !isPortrait) && (
        <>
          <div className={cn('imgWrapper')}>
            {!scenarios[currentScenarioIndex]?.isScore && (
              <Animation animation={AnimationTraining} />
            )}
            {scenarios[currentScenarioIndex]?.isScore &&
              (currentScenarioIndex === 0 ||
                (currentScenarioIndex + (!scenarios[0].isScore ? 3 : 0)) % 4 ===
                  0) && <Animation animation={AnimationBuyer1} />}
            {scenarios[currentScenarioIndex]?.isScore &&
              (currentScenarioIndex + (!scenarios[0].isScore ? 2 : 3)) % 4 ===
                0 && <Animation animation={AnimationBuyer2} />}
            {scenarios[currentScenarioIndex]?.isScore &&
              (currentScenarioIndex + (!scenarios[0].isScore ? 1 : 2)) % 4 ===
                0 && <Animation animation={AnimationBuyer3} />}
            {scenarios[currentScenarioIndex]?.isScore &&
              (currentScenarioIndex + (!scenarios[0].isScore ? 0 : 1)) % 4 ===
                0 && (
                <img
                  src={AnimationBuyer4}
                  className={cn('img')}
                  alt="Покупатель"
                />
              )}
          </div>
          <img src={srcCashbox} className={cn('imgCashbox')} alt="Касса" />
        </>
      )}
      <Layout className={cn('container')}>
        <Header
          numberQuestion={numberQuestion}
          questions={questions}
          scenarios={scenarios}
          points={points}
          responseStatus={responseStatus}
        />
        {isMobile && isPortrait ? (
          <div className={cn('wrap')}>
            <Message className={cn('message')}>{message}</Message>
            <div className={cn('imgWrapper')}>
              {!scenarios[currentScenarioIndex]?.isScore && (
                <Animation animation={AnimationTraining} />
              )}
              {scenarios[currentScenarioIndex]?.isScore &&
                (currentScenarioIndex === 0 ||
                  (currentScenarioIndex + (!scenarios[0].isScore ? 3 : 0)) %
                    4 ===
                    0) && <Animation animation={AnimationBuyer1} />}
              {scenarios[currentScenarioIndex]?.isScore &&
                (currentScenarioIndex + (!scenarios[0].isScore ? 2 : 3)) % 4 ===
                  0 && <Animation animation={AnimationBuyer2} />}
              {scenarios[currentScenarioIndex]?.isScore &&
                (currentScenarioIndex + (!scenarios[0].isScore ? 1 : 2)) % 4 ===
                  0 && <Animation animation={AnimationBuyer3} />}
              {scenarios[currentScenarioIndex]?.isScore &&
                (currentScenarioIndex + (!scenarios[0].isScore ? 0 : 1)) % 4 ===
                  0 && (
                  <img
                    src={AnimationBuyer4}
                    className={cn('img')}
                    alt="Покупатель"
                  />
                )}
            </div>
            <img src={srcCashbox} className={cn('imgCashbox')} alt="Касса" />
            {!isMobile && (
              <Button handleClick={startTraining} className={cn('button')}>
                {button}
              </Button>
            )}
          </div>
        ) : (
          <>
            <Message className={cn('message')}>{message}</Message>
            {!isMobile && (
              <Button handleClick={startTraining} className={cn('button')}>
                {button}
              </Button>
            )}
          </>
        )}
      </Layout>
      {isMobile && (
        <Button handleClick={startTraining} className={cn('button')}>
          {button}
        </Button>
      )}
    </>
  );
};

export default Background;
